import { environment } from './../../../environment/environment';
import { SortDataService } from './../../core/services/sortdata';
import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  blockSuccess,
  deblockSuccess,
  dejabloque,
  serverError,
} from './../../core/models/messages';
import { CallOfferService } from './../../core/services/call-offer-service/call-offer.service';
import { CompanyService } from './../../core/services/company/company.service';
import { EsnAppeloffreService } from './../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Country } from 'country-state-city';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { translations } from '../../core/models/call-offer';

@Component({
  selector: 'app-listesncalloffer',
  templateUrl: './listesncalloffer.component.html',
  styleUrls: ['./listesncalloffer.component.css'],
})
export class ListesncallofferComponent {
  isCollapsed = true; // Initial state
  private unsubscribeAll: Subject<void> = new Subject();
  /* any */
  file: any;
  selectedImage: any;
  /* modal */
  //  modalRef?: BsModalRef;
  /* object */
  responsableCompany: any;
  /* arrays */
  listCampany: any = [];
  dataHeader: any = [];
  listNames: string[] = [];
  typesCompanies = [
    { id: 1, name: 'Entreprise' },
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  /* number */
  totalItems!: number;
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 1;

  startIndex: number = 0;
  endIndex: number = 5;

  /* string */
  mode: string = 'create';
  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;
  fileError: string = '';
  fileExtention: string = '';
  fileName: string = '';
  /* formGroup */
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  loadSpinner: boolean = false;
  companyType = new FormControl();
  /* form data */
  formData = new FormData();
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  typeCompany = [
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  currentSortColumn: string = 'name';

  /* unsubscription */

  searchForm: FormGroup = this.createSearchForm();
  pays = [
    { id: 1, name: 'France' },
    { id: 2, name: 'Tunisie' },
    { id: 3, name: 'Turquie' },
    { id: 4, name: 'Allemagne' },
  ];
  sortAttr = '';
  id = this.activeroute.snapshot.params['id'];
  isLoadSpinner: boolean = true;

  constructor(
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private activeroute: ActivatedRoute,
    private appelOffreService: EsnAppeloffreService,
    private callofferservice: CallOfferService,
    private toastr: ToastrService,
    private router: Router,
    private datePipe: DatePipe,
    private sortdata: SortDataService
  ) {}
  ngOnInit() {
    this.getListCompanies();
    this.getListElementHeader();
  }
  getListElementHeader() {
    this.appelOffreService
      .getHeaderElements(12)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
    };
  }
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }

  /* get indexes for pagination */
  getItems(event?: any) {
    console.log('evnet', event);

    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCompnies();
      } if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListCompanies();
      }
    }
  }
  handleRatingClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('bs-rating-star')) {
      // Check if the "active" class is present
      const isActive = target.classList.contains('active');
      // Toggle the "active" class
      target.classList.toggle('active', !isActive);
    }
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    console.log('form', this.searchForm.value);
    if (this.searchForm.dirty)
      this.listCampany = this.sortdata.sortArray(
        this.listCampany,
        this.sortAttr,
        this.currentSortDirection
      );
    this.getListCompanies();
  }

  /* list list esn companies */
  getListCompanies() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? { per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.callofferservice
      .getListesncalloffer(this.id, dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listCampany = res.data.data
          // .slice(0, this.endIndex);
          console.log('list company call offer', this.listCampany);
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  //////////////////////////////date de creation pour afficher dans la liste ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));
      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    // this.addCandidateFormGroup.markAsDirty();
  }

  //////////////////////////////////////////bloquer/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  bloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de bloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, bloquer',
      cancelButtonText: 'Annuler', // Changer le texte du bouton Cancel ici
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(
          '%centreprises.component.ts line:212 idCompany+++',
          'color: #007acc;',
          idCompany
        );

        this.blockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  debloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de débloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'oui, débloquer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deblockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  /* deblock  company */
  deblockCompany(idCompany: any) {
    this.spinner.show();
    this.companyService
      .deblockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(deblockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  /* block  company */
  blockCompany(idCompany: any) {
    this.spinner.show();
    console.log(
      '%centreprises.component.ts line:221 idCompany',
      'color: #007acc;',
      idCompany
    );
    this.companyService
      .blockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(blockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.toastr.error(dejabloque);
        },
      });
  }

  /* search */
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      date: [data ? data.date : ''],
      company_name: [data ? data.company_name : ''],
    });
  }

  searchCompnies() {
    let data = {
      date: this.searchForm.value?.date
        ? moment(this.searchForm.value?.date).format('YYYY-MM-DD')
        : null,
      company_name: this.searchForm.value?.company_name,
    };
    this.spinner.show();
    console.log('data', data);
    this.callofferservice
      .searchesncallOffer(this.id, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log(res);
          if ( this.currentPage > 1) {
            this.currentPage = 1;
            this.searchCompnies();
          } else {
            this.listCampany = res.data.data.slice(0, this.endIndex);
            this.spinner.hide();
          }
        },
        error: (err) => {
          console.log('error', err);
          this.spinner.hide();
        },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    search = search.replace(/\s+/g, ' ');

    return search.trim();
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchCompnies();
  }

  /* ************************* navigation contact responsable ********************* */
  contactResponsableNavigation(id: any) {
    this.router.navigate(['/contact', { idResponsable: id }]);
  }

  /* ************************* navigation company ********************* */

  /* ************************* navigation contact responsable ********************* */
  reviewCompanyNavigation(id: any) {
    this.router.navigate(['/evaluer-esn', { id: id }]);
  }
}
